import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiPost } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { Cpu, Lock, User, LogIn, ArrowLeft } from "lucide-react";

export default function SuperAdminLogin() {
  const { login } = useApp();
  const navigate = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [busy, setBusy] = useState(false);
  const signIn = async () => {
    setBusy(true);
    try { const r = await apiPost("/auth/super-login", { username: u, password: p }); login(r.user); toast.success("Super-admin session started"); navigate("/admin/super"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Invalid credentials"); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "radial-gradient(60% 60% at 50% 20%, hsl(208 56% 20%), hsl(213 40% 10%))" }}>
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm rounded-2xl border border-white/10 bg-white/95 p-8 shadow-2xl">
        <div className="flex flex-col items-center mb-6">
          <span className="h-20 w-20 rounded-full bg-navy flex items-center justify-center mb-3 shadow-lg"><Cpu className="h-9 w-9 text-gold" /></span>
          <p className="font-display text-xl text-ink">Super Admin</p>
          <p className="text-xs uppercase tracking-widest text-muted-foreground mt-1">Navitra OS · System</p>
        </div>
        <div className="space-y-3">
          <div><Label className="text-xs">Username</Label><div className="flex items-center gap-2 rounded-lg border px-3 py-2 mt-1"><User className="h-4 w-4 text-muted-foreground" /><Input value={u} onChange={(e) => setU(e.target.value)} placeholder="Username" className="border-0 shadow-none focus-visible:ring-0 px-1" data-testid="super-user" /></div></div>
          <div><Label className="text-xs">Password</Label><div className="flex items-center gap-2 rounded-lg border px-3 py-2 mt-1"><Lock className="h-4 w-4 text-muted-foreground" /><Input type="password" value={p} onChange={(e) => setP(e.target.value)} onKeyDown={(e) => e.key === "Enter" && signIn()} placeholder="Password" className="border-0 shadow-none focus-visible:ring-0 px-1" data-testid="super-pass" /></div></div>
        </div>
        <Button className="w-full mt-5" size="lg" onClick={signIn} disabled={busy} data-testid="super-signin"><LogIn className="h-4 w-4 mr-2" />{busy ? "Authenticating…" : "Sign in"}</Button>
        <button onClick={() => navigate("/")} className="w-full mt-4 text-xs text-muted-foreground hover:text-navy flex items-center justify-center gap-1"><ArrowLeft className="h-3 w-3" />Back to home</button>
      </motion.div>
    </div>
  );
}
